import TOP from './top.base64'
import BOTTOM from './bottom.base64'

export default {
  TOP,
  BOTTOM
}